import { useApiClient } from "@/hooks/useApiClient";
import useSWR from "swr";

export interface ClientConsumeDetailResponse {
  id: number;
  userName: string;
  quantity: number;
  itemName: string;
  consumeCredit: number;
  createdAt: string;
}

export const useClientConsumeDetails = (
  year: number,
  month: number
): ClientConsumeDetailResponse[] => {
  const { apiClient } = useApiClient();
  const params = {
    year,
    month,
  };
  const url = "/credit/client-consume-details";

  const fetcher = async (): Promise<ClientConsumeDetailResponse[]> => {
    return (
      await apiClient.get<ClientConsumeDetailResponse[]>(url, {
        params,
      })
    ).data;
  };
  const { data: consumesDetail } = useSWR({ url, params }, fetcher, {
    revalidateOnFocus: false,
  });

  return consumesDetail ?? [];
};
